<script>
    import { _ } from "svelte-i18n";

    import LocalizableField from "./LocalizableField.svelte";

    export let form;
    export let values = {};
    export let errors = {};
    export let valid;
    export let locale;
    let validity = {};

    const checkIfValid = (validity) => {
        return !Object.values(validity).some((it) => !it);
    };

    $: valid = checkIfValid(validity);
</script>

<form on:submit|preventDefault class="flex flex-wrap">
    <slot name="header">HEADER</slot>
    {#each form.fields as field}
        <LocalizableField
            {locale}
            {field}
            bind:value={values[field.id]}
            bind:valid={validity[field.id]}
            bind:error={errors[field.id]} />
    {/each}
    <slot name="footer" />
</form>
